enum FavoriteTypesEnum {
  MyProject = 1,
  ProjectWorkQueue = 2,
  AllProjects = 3,
  AllProjectsPmr = 4,
  ProjectWorkQueuePmr = 5,
}

export default FavoriteTypesEnum
